import { useLastPerpTradesByInstrument } from "#/hooks/useLastPerpTradesByInstrument";
import { useMarketIndexPrice } from "#/store/app/indexPrices/marketIndexPrice";
import { useShowTradePanel } from "#/store/app/tradePanel/showTradePanel";
import { useTradePanelTab } from "#/store/app/tradePanel/tradePanelTab";
import { usePerpsOrderbook } from "#/store/perps/page/perpsOrderbook";
import { useTickSize } from "#/store/perps/page/tickSize";
import { usePerpIsBuy } from "#/store/perps/tradePanel/perpIsBuy";
import { usePerpLimitPrice } from "#/store/perps/tradePanel/perpLimitPrice";
import { usePerpTradeType } from "#/store/perps/tradePanel/perpTradeType";
import { type OrderbookEntry } from "#/types/orderbook";

export const usePerpsOrderbookController = () => {
  const { tickSize, tickSizes, setTickSizeIndex } = useTickSize();
  const { setPerpIsBuy } = usePerpIsBuy();
  const { setPerpLimitPrice, setUpdateTime } = usePerpLimitPrice();
  const { setShowTradePanel } = useShowTradePanel();
  const { setTradePanelTab } = useTradePanelTab();
  const { isLimit } = usePerpTradeType();

  const { lastTrade, isLoading } = useLastPerpTradesByInstrument();
  const { perpsOrderbook } = usePerpsOrderbook();
  const { marketIndexPrice } = useMarketIndexPrice();

  const isOrderbookLoading =
    perpsOrderbook.buys.length === 0 &&
    perpsOrderbook.sells.length === 0 &&
    isNaN(marketIndexPrice);

  const handleSetTickSize = (value: string) => {
    const index = tickSizes.indexOf(Number(value));
    setTickSizeIndex(index);
  };

  const handleSelectRow = (entry: OrderbookEntry, isBuy: boolean) => {
    setPerpLimitPrice(String(entry.price));
    setUpdateTime(new Date().getTime());
    setShowTradePanel(true);
    setTradePanelTab("perps");
    if (!isLimit) setPerpIsBuy(!isBuy); // works fine for RFQ as well;
  };

  return {
    tickSize,
    tickSizes,
    lastTrade,
    isLoading,
    perpsOrderbook,
    marketIndexPrice,
    handleSelectRow,
    handleSetTickSize,
    isOrderbookLoading,
  };
};
